<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container >Submit Change to Listing</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <p>Use the form below to submit changes or updates to this directory listing.</p>
    <div class="form-container">
      <fieldset class="fieldset-container">
        <p id="disclaimer">Providing contact information is optional and will only be used if there are questions about the information submitted below.</p>
        <p>
          <mat-form-field class="change-form">
            <input matInput
                   placeholder="Name"
                   formControlName="name">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="change-form">
            <input matInput
                   placeholder="Email"
                   formControlName="email">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="change-form">
            <textarea matInput placeholder="Details (Required)" formControlName="details" rows="7"></textarea>
          </mat-form-field>
        </p>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="submit()">
      Submit
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
